/* eslint-disable import/prefer-default-export */
export enum LaunchDarklyFlags {
    SalesCompliance = 'sales-compliance',
    ExpiredNews = 'expired-news',
    AdminIntegrations = 'admin-integrations',
    PecoQualtrics = 'peco-qualtrics',
    MriEnabled = 'mri-enabled',
    I18n = 'i18n',
    Payments = 'payments',
    PaymentsMarketing = 'payments-marketing',
    ComplianceHub = 'compliance-hub',
    ComplianceBuilder = 'compliance-builder',
    LeasingApplicationEditing = 'leasing-application-editing',
    ReportsV2 = 'reports-v-2',
    MriDrivenLeasingStatuses = 'mri-driven-leasing-statuses',
    LeasingApplicationRescue = 'leasing-application-rescue',
    LeasingApplicationCloning = 'leasing-application-cloning',
    InvitationUrlAccess = 'invitation-url-access',
    PartnerApiKeys = 'partner-api-keys',
}
